import React, { useContext, useEffect } from 'react'
import 'stylesheets/TimerAppStyles/SessionEnd.css'
import { Alignment, Fit, Layout, useRive, useStateMachineInput } from '@rive-app/react-canvas'
import { ClockContext } from 'contexts/TimerAppContexts/ClockContext'
import { AppContext } from 'contexts/TimerAppContexts/AppContext'
import { TodoContext } from 'contexts/TimerAppContexts/TodoContext'

const SessionEnd = () => {
    const CONGRATS_INPUT = "StartCongrats"
    const CONGRATS_STATE_MACHINE_NAME = "Congrats Machine"

    const { rive: plantEndRive, RiveComponent: PlantEnd } = useRive({
        src: `${process.env.PUBLIC_URL}/session-end.riv`,
        animations: "Planta Loop",
        artboard: "Plant-Circle",
        autoplay: true,
        layout: new Layout({
            fit: Fit.Width,
            alignment: Alignment.Center,
        }),
        stateMachines: CONGRATS_STATE_MACHINE_NAME,
    });

    const congratsTrigger = useStateMachineInput(
        plantEndRive,
        CONGRATS_STATE_MACHINE_NAME,
        CONGRATS_INPUT,
    )

    
    const { sessionEnd } = useContext(ClockContext)
    const { setOpenTimerModal, timerKey } = useContext(AppContext);
    const { addPomodoroEnd } = useContext(TodoContext);

    useEffect(() => {
        if (congratsTrigger !== null && sessionEnd === true) {
            congratsTrigger.value = true
        }
    }, [sessionEnd, congratsTrigger])

    const handleCongratsClick = ()=>{
        setOpenTimerModal(false)
        addPomodoroEnd(timerKey)
    }

    return (
        <div className="congrats-main-container">
            <div className="background-square"></div>
            <div className="background-square"></div>
            <div className="background-square"></div>
            <div className="background-square"></div>
            <div className='congrats-text'>
                <h1>Congrats!</h1>
                <h2>You finished the task</h2>
                <p>Click <b>Continue</b> to return to the main page</p>
            </div>
            <PlantEnd className='congrats-container' />
            <button className='congrats-button' onClick={handleCongratsClick}>Continue</button>
        </div>
    )
}

export { SessionEnd }